import { render, staticRenderFns } from "./PhoneticNameForm.vue?vue&type=template&id=2fe96e70&"
import script from "./PhoneticNameForm.vue?vue&type=script&lang=ts&"
export * from "./PhoneticNameForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports